import React, { createContext, useState } from "react";

export const NavContext = createContext();

function NavContextProvider(props) {
  const [navigation, setNavigation] = useState(false);

  return (
    <NavContext.Provider value={{ navigation, setNavigation }}>
      {props.children}
    </NavContext.Provider>
  );
}

export default NavContextProvider;
